import { Chip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function VariantComparisonChip({ item: variant, index }) {
    const { onRemoveVariant } = useBoundContext()
    const isFirst = index === 0

    return (
        <Chip
            label={variant.name}
            color={isFirst ? "primary" : "default"}
            onDelete={isFirst ? undefined : handleDelete}
            sx={{ fontWeight: 600 }}
        />
    )

    function handleDelete() {
        onRemoveVariant(variant.id)
    }
}
